'use strict';

import { Entity } from '../Entity';
import { GlobPlansDisruptionCollection } from '../../Collections/Glob/GlobPlansDisruptionCollection';
import { GlobPlansDisruption } from '../../Entities/Glob/GlobPlansDisruption';

export class GlobPlans extends Entity {
  protected planId;

  protected planState;

  protected planCounty;

  protected companyId;

  protected planName;

  protected planType;

  protected planNumber;

  protected company;

  protected disruptions;

  constructor() {
    super();
  }

  public hydrate(data: any) {
    this.planId = data.planId;

    this.planState = data.planState;

    this.planCounty = data.planCounty;

    this.companyId = data.companyId;

    this.planName = data.planName;

    this.planType = data.planType;

    this.planNumber = data.planNumber;

    this.company = data.company;

    if (data.disruptions) {
      const disruptions = new GlobPlansDisruptionCollection();

      data.disruptions.forEach((singleDisruptionData) => {
        const disruption = new GlobPlansDisruption();
        disruption.hydrate(singleDisruptionData);

        disruptions.addItem(disruption);
      });

      this.disruptions = disruptions;
    }
  }

  public getPlanId() {
    return this.planId;
  }

  public setPlanId(planId) {
    this.planId = planId;

    return this;
  }

  public getPlanState() {
    return this.planState;
  }

  public setPlanState(planState) {
    this.planState = planState;

    return this;
  }

  public getPlanCounty() {
    return this.planCounty;
  }

  public setPlanCounty(planCounty) {
    this.planCounty = planCounty;

    return this;
  }

  public getCompanyId() {
    return this.companyId;
  }

  public setCompanyId(companyId) {
    this.companyId = companyId;

    return this;
  }

  public getPlanName() {
    return this.planName;
  }

  public setPlanName(planName) {
    this.planName = planName;

    return this;
  }

  public getPlanType() {
    return this.planType;
  }

  public setPlanType(planType) {
    this.planType = planType;

    return this;
  }

  public getPlanNumber() {
    return this.planNumber;
  }

  public setPlanNumber(planNumber) {
    this.planNumber = planNumber;

    return this;
  }

  public getDisruptions() {
    return this.disruptions;
  }
}
